import { render, staticRenderFns } from "./ItemDatas.vue?vue&type=template&id=0c817625&scoped=true&"
import script from "./ItemDatas.vue?vue&type=script&lang=js&"
export * from "./ItemDatas.vue?vue&type=script&lang=js&"
import style0 from "./ItemDatas.vue?vue&type=style&index=0&id=0c817625&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c817625",
  null
  
)

export default component.exports